export type Role = 'SYS_ADMIN' | 'PRESIDENT' | 'VICE_PRESIDENT'
  | 'WDC_PRESIDENT' | 'WDC_VICE_PRESIDENT' | 'WDC_MEMBER'
  | 'SECRETARY_GENERAL' | 'MEMBER' | 'BUREAU_STAFF' | 'VIEWER';

export const dv = {
  appName: 'ވެޕްމީޓް',
  common: {
    save: 'ސޭވްކުރޭ', cancel: 'ކެންސަލް', edit: 'އެޑިޓްކުރޭ', delete: 'ޑިލީޓްކުރޭ',
    loading: 'ލޯޑްވަނީ…', back: 'އަނބުރާ', close: 'ބަންދުކުރޭ', submit: 'ހުށަހަޅާ',
    download: 'ޑައުންލޯޑް', downloading: 'ޑައުންލޯޑްވަނީ…', error: 'މައްސަލައެއް ދިމާވެއްޖެ. އަލުން މަސައްކަތްކޮށްލައްވާ',
    required: 'މި ފީލްޑް ފުރިހަމަކުރައްވާ', none: 'ނެތް', confirm: 'ޔަގީންކުރޭ',
    active: 'އެކްޓިވް', inactive: 'ޑީއެކްޓިވޭޓްކޮށްފައި', suspended: 'ސަސްޕެންޑްކޮށްފައި',
    page: 'ޞަފްޙާ', next: 'ކުރިއަށް', prev: 'ފަހަތަށް',
    retry: 'އަލުން މަސައްކަތްކުރޭ',
  },
  auth: {
    login: 'ވަންނަން', email: 'އީމެއިލް', password: 'ޕާސްވޯޑް',
    forgotPassword: 'ޕާސްވޯޑް ހަނދާން ނެތުނީތަ؟',
    resetPassword: 'ޕާސްވޯޑް ބަދަލުކުރޭ', newPassword: 'އައު ޕާސްވޯޑް',
    confirmPassword: 'ޕާސްވޯޑް ޔަގީންކުރޭ', passwordMismatch: 'ދެ ޕާސްވޯޑް ދިމައެއް ނުވޭ',
    invalidCredentials: 'އީމެއިލް ނުވަތަ ޕާސްވޯޑް ރަނގަޅެއް ނޫން',
    logout: 'ލޮގްއައުޓް', yourName: 'ފުރިހަމަ ނަން',
    acceptInviteTitle: 'އެކައުންޓް ހެދުން', acceptInvite: 'އެކައުންޓް ހަދާ',
    resetSent: 'ޕާސްވޯޑް ބަދަލުކުރާ ލިންކް އީމެއިލްކޮށްފީމެވެ',
    sendResetLink: 'ލިންކް ފޮނުވާ',
    resetLinkExpired: 'މި ލިންކްގެ މުއްދަތު ހަމަވެއްޖެ. އަލުން ލިންކެއް ހޯއްދަވާ',
    profile: 'ޕްރޮފައިލް', changePassword: 'ޕާސްވޯޑް ބަދަލުކުރުން',
    currentPassword: 'މިހާރުގެ ޕާސްވޯޑް', passwordChanged: 'ޕާސްވޯޑް ބަދަލުކޮށްފި',
    saved: 'ސޭވްކޮށްފި',
    showPassword: 'ޕާސްވޯޑް ދައްކާ', hidePassword: 'ޕާސްވޯޑް ފޮރުވާ',
    signingIn: 'ވަންނަނީ…',
    handoffInvalid: 'މި ލިންކް ބޭނުން ނުކުރެވޭ ނުވަތަ މުއްދަތު ހަމަވެއްޖެ',
  },
  demo: {
    preparing: 'ޑިމޯ ތައްޔާރުކުރަނީ…',
    error: 'ޑިމޯ ފެށުމުގައި މައްސަލައެއް ދިމާވެއްޖެ',
    retry: 'އަލުން މަސައްކަތްކުރޭ',
    banner: 'ޑިމޯ — މިއީ ޓެސްޓް ކައުންސިލެއް. ބަދަލުތައް ދާއިމީއެއް ނުވާނެ',
    exit: 'ޑިމޯއިން ނުކުތުން',
  },
  nav: {
    dashboard: 'ޑޭޝްބޯޑް', meetings: 'ބައްދަލުވުންތައް', users: 'ޔޫޒަރުން',
    orgs: 'ކައުންސިލްތައް', notifications: 'ނޮޓިފިކޭޝަން', profile: 'ޕްރޮފައިލް',
    settings: 'ސެޓިންގްސް', wapsign: 'ވެޕްސައިން', statistics: 'ތަފާސްހިސާބު',
    thanfeezu: 'ތަންފީޒު',
  },
  roles: {
    SYS_ADMIN: 'ސިސްޓަމް އެޑްމިން',
    PRESIDENT: 'ކައުންސިލްގެ ރައީސް',
    VICE_PRESIDENT: 'ނައިބު ރައީސް',
    WDC_PRESIDENT: 'އ.ތ.މ. ކޮމިޓީގެ ރައީސާ',
    WDC_VICE_PRESIDENT: 'އ.ތ.މ. ކޮމިޓީގެ ނައިބު ރައީސާ',
    WDC_MEMBER: 'އ.ތ.މ. ކޮމިޓީގެ މެންބަރު',
    SECRETARY_GENERAL: 'ސެކްރެޓަރީ ޖެނެރަލް',
    MEMBER: 'ކައުންސިލް މެންބަރު',
    BUREAU_STAFF: 'ބިއުރޯ ސްޓާފް',
    VIEWER: 'ބެލުންތެރިޔާ',
  } satisfies Record<Role, string>,
  body: { COUNCIL: 'ކައުންސިލް', WDC: 'އ.ތ.މ. ކޮމިޓީ', label: 'ހިންގާ ފަރާތް', all: 'ހުރިހާ' } as Record<string, string>,
  orgAdminBadge: 'އެޑްމިން',
  president: {
    // Profile leave toggle (only the president sees it).
    leaveTitle: 'ޗުއްޓީ — ނައިބު ރައީސްއާ ޒިންމާ ހަވާލުކުރުން',
    leaveLabel: 'ޗުއްޓީ',
    toggleOn: 'އޮން',
    toggleOff: 'އޮފް',
    leaveDescription: 'ޗުއްޓީގައި ހުންނަ މުއްދަތުގައި ނައިބު ރައީސް، ރައީސްގެ ބަދަލުގައި ކައުންސިލްގެ އެޖެންޑާގައި ސޮއިކުރައްވައި، ރައީސްގެ އެންމެހާ ބާރުތައް ބޭނުންކުރައްވާނެއެވެ',
    onLeave: 'ޗުއްޓީގައި',
    onLeaveOn: 'އަޅުގަނޑު މިހާރު ޗުއްޓީގައި — ނައިބު ރައީސްއާ ޒިންމާ ހަވާލުކޮށްފައި',
    onLeaveOff: 'އަޅުގަނޑު ޗުއްޓީގައެއް ނޫން',
    leaveConfirmOn: 'ޗުއްޓީ ޖައްސަވައި ނައިބު ރައީސްއާ ޒިންމާ ހަވާލުކުރައްވަން ޔަގީންތޯ؟',
    leaveConfirmOff: 'ޗުއްޓީ ނިންމަވައި އަލުން ޒިންމާ ނަންގަވަން ޔަގީންތޯ؟',
    leaveSaved: 'ބަދަލުކޮށްފި',
    // Banner shown to the VP while they are acting president.
    actingNotice: 'ތިޔަ މިހާރު ރައީސްގެ ބަދަލުގައި އަމަލުކުރައްވަނީ',
  },
  profile: {
    nameInOffice: 'މެނޭޖްކުރަނީ ވެޕްލިފައި އޮފީހުގައި',
    notifyNinmunTitle: 'ނިންމުންތަކުގެ އީމެއިލް',
    notifyNinmunLabel: 'ނިންމުންތައް އީމެއިލް ކުރޭ',
    notifyNinmunHelp: 'ނިންމުމެއް ފާސްވުމުން، ސޮއިކުރެވިފައިވާ ނިންމުން ތިޔަ އީމެއިލްއަށް ފޮނުވޭނެ.',
  },
  orgs: {
    title: 'ކައުންސިލްތައް', create: 'އައު ކައުންސިލެއް', name: 'ކައުންސިލްގެ ނަން',
    contactEmail: 'ގުޅޭނެ އީމެއިލް', users: 'ޔޫޒަރުން', created: 'އުފެއްދި ތާރީޚު',
    inviteAdmin: 'އެޑްމިން އިންވައިޓްކުރޭ', adminRole: 'އެޑްމިންގެ މަގާމު',
    suspend: 'ސަސްޕެންޑްކުރޭ', activate: 'އެކްޓިވޭޓްކުރޭ',
    inviteSent: 'އިންވައިޓް އީމެއިލްކޮށްފި', empty: 'އަދި ކައުންސިލެއް ނެތް',
  },
  users: {
    title: 'ޔޫޒަރުން', invite: 'ޔޫޒަރެއް އިންވައިޓްކުރޭ', name: 'ނަން',
    role: 'މަގާމު', status: 'ހާލަތު', orgAdmin: 'އެޑްމިން ހުއްދަ',
    designationDv: 'މަޤާމު (ދިވެހި)', designationEn: 'މަޤާމު (އިނގިރޭސި)',
    editDesignation: 'މަޤާމު އެޑިޓްކުރޭ',
    deactivate: 'ޑީއެކްޓިވޭޓްކުރޭ', activate: 'އެކްޓިވޭޓްކުރޭ',
    pendingInvites: 'ފޮނުވާފައިވާ އިންވައިޓްތައް', revokeInvite: 'އިންވައިޓް ކެންސަލްކުރޭ',
    inviteSent: 'އިންވައިޓް އީމެއިލްކޮށްފި', expires: 'މުއްދަތު ހަމަވަނީ',
    empty: 'އަދި ޔޫޒަރެއް ނެތް',
    sendReset: 'ޕާސްވޯޑް ރީސެޓް ލިންކް ފޮނުވާ',
    resetShort: 'ޕާސްވޯޑް ރީސެޓް',
    resetSent: 'ރީސެޓް ލިންކް އީމެއިލްކޮށްފި',
    managedInOffice: 'ޔޫޒަރުން މެނޭޖްކުރަނީ ވެޕްލިފައި އޮފީހުގައި',
    managedInOfficeHint: 'ޔޫޒަރުން އިތުރުކުރުމާއި، މަގާމު ބަދަލުކުރުމާއި، އެކްޓިވޭޓް/ޑީއެކްޓިވޭޓްކުރުން ކުރެވޭނީ ވެޕްލިފައި އޮފީހުންނެވެ',
    passwordInOffice: 'ޕާސްވޯޑް ބަދަލުކުރަނީ ވެޕްލިފައި އޮފީހުގައި',
    passwordInOfficeHint: 'ޕާސްވޯޑް ބަދަލުކުރުމަށް ވެޕްލިފައި އޮފީސް ހުޅުވާ',
    openOffice: 'އޮފީސް ހުޅުވާ',
  },
  settings: {
    title: 'ސެޓިންގްސް',
    usersTab: 'ޔޫޒަރުން',
    orgTab: 'ޕްރިފަރެންސް',
    headerImage: 'ޑޮކިއުމަންޓް ހެޑަރ',
    footerImage: 'ޑޮކިއުމަންޓް ފުޓަރ',
    footerText: 'ފުޓަރ ލިޔުން',
    uploadImage: 'ފޮޓޯއެއް އަޕްލޯޑްކުރޭ',
    removeImage: 'ފޮޓޯ ނަގާ',
    letterheadHint: 'މި ހެޑަރ އާއި ފުޓަރ ބޭނުންކުރެވޭނީ އެޖެންޑާ ޑޮކިއުމަންޓްތަކުގައެވެ',
    headerSizeHint: 'ރަނގަޅު ސައިޒް: 2048×410 ޕިކްސެލް · PNG ނުވަތަ JPEG · އެންމެ ބޮޑު 2MB',
    footerSizeHint: 'ރަނގަޅު ސައިޒް: 2048×270 ޕިކްސެލް · PNG ނުވަތަ JPEG · އެންމެ ބޮޑު 2MB',
    termNumber: 'ހިނގަމުންދާ ދައުރު (ނަންބަރު)',
    saved: 'ސޭވްކޮށްފި',
    numberFormatting: 'ނަންބަރު ފޯމެޓް',
    agendaNumberFormat: 'އެޖެންޑާ ނަންބަރު',
    yaumiyyaNumberFormat: 'ޔައުމިއްޔާ ނަންބަރު',
    ninmunNumberFormat: 'ނިންމުން ނަންބަރު',
    agendaNumberNext: 'ދެން އަންނަ ނަންބަރު',
    agendaNumberHint: 'ބޭނުންކުރެވޭ: {TERM} = ދައުރު · {YYYY} / {YY} = އަހަރު · {###} = ނަންބަރު (ސުމަކުން ފުރިހަމަކޮށް) · އެހެން ހުރިހާ އަކުރެއް ހުންނާނީ ލިޔުނު ގޮތަށް. މިސާލު: AGD438/{TERM}/{YYYY}/{###}',
    agendaNumberPreview: 'މިސާލު',
    termsTab: 'ދައުރުތައް',
    addTerm: 'ދައުރެއް އިތުރުކުރޭ',
    termNumberLabel: 'ދައުރު ނަންބަރު',
    termStart: 'ފެށޭ ތާރީޚު',
    termEnd: 'ނިމޭ ތާރީޚު',
    activeTerm: 'ހިނގަމުންދާ ދައުރު',
    makeActive: 'މި ދައުރަށް ބަދަލުކުރޭ',
    noTerms: 'އަދި ދައުރެއް ނެތް',
    termExists: 'މި ނަންބަރުގެ ދައުރެއް މިހާރުވެސް އެބައޮތް',
    termInUse: 'މި ދައުރުގައި ބައްދަލުވުން އެބަހުރި — ޑިލީޓެއް ނުކުރެވޭނެ',
    termMeetings: 'ބައްދަލުވުން',
    exportTab: 'ޑޭޓާ އެކްސްޕޯޓް',
    export: {
      title: 'ބައްދަލުވުމުގެ ޑޭޓާ އެކްސްޕޯޓް',
      intro: 'ދައުރެއް ހޮއްވަވާ، އެ ދައުރުގެ ހުރިހާ ބައްދަލުވުމެއްގެ ޑޮކިއުމަންޓްތަކާއި (އެޖެންޑާ، ޔައުމިއްޔާ، ނިންމުން، ހާޒިރީ) އަދި ހުރިހާ ބައްދަލުވުމެއްގެ ތަފްސީލް ހިމެނޭ އެކްސެލް ޝީޓެއް ޒިޕް ފައިލެއްގެ ގޮތުގައި ޑައުންލޯޑް ކުރައްވާ. ކޮންމެ ބައްދަލުވުމަކަށް ވަކި ފޯލްޑަރެއް.',
      selectTerm: 'ދައުރު',
      allTerms: 'ހުރިހާ ދައުރެއް',
      download: 'އެކްސްޕޯޓް ކުރޭ',
      preparing: 'ތައްޔާރުކުރަނީ…',
      error: 'އެކްސްޕޯޓް ނުކުރެވުނު. އަލުން މަސައްކަތްކުރައްވާ.',
    },
    // Meeting-cadence requirement (minvaru)
    meetingCadence: {
      title: 'ބައްދަލުވުން ބޭއްވުމުގެ މިންވަރު',
      help: 'ޤާނޫނީ ގޮތުން ކައުންސިލުން ބައްދަލުވުން ބާއްވަންޖެހޭ މިންވަރު. މި ހޮއްވުމުން «މިންވަރު» ޞަފްޙާގައި ފުރިހަމަކުރި މިންވަރު ދައްކާނެ.',
      notSet: 'ކަނޑައަޅާފައި ނެތް',
      weekly: 'ކޮންމެ ހަފްތާއަކު',
      monthly: 'ކޮންމެ މަހަކު',
    },
    // Quorum — the fixed minimum number of voting councilors for a valid meeting.
    quorum: {
      title: 'ކޯރަމް',
      help: 'ބައްދަލުވުމެއް ޞައްޙަކަމާއެކު ބޭއްވުމަށް ޙާޟިރުވާންޖެހޭ އެންމެ މަދު ވޯޓުދޭ މެންބަރުންގެ ޢަދަދު. ކޯރަމް ހަމަނުވާ ބައްދަލުވުމެއް ޞައްޙަ ގޮތުގައި ކުރިއަކަށް ނުގެންދެވޭނެއެވެ.',
      notSet: 'ކަނޑައަޅާފައި ނެތް',
      placeholder: 'ޢަދަދު',
    },
    // Chair delegation — succession + per-member leave.
    chair: {
      title: 'ރިޔާސަތު ހަވާލުކުރުން',
      help: 'ރައީސް ޗުއްޓީގައި ހުންނަވާނަމަ، ރިޔާސަތު ދެން ދާނީ ތަރުތީބުން ޗުއްޓީގައި ނެތް ފުރަތަމަ ފަރާތަށެވެ: ރައީސް ← ނައިބު ރައީސް ← މެންބަރުން. މެންބަރުންގެ ތަރުތީބު ބަދަލުކުރެވޭނެއެވެ.',
      actingNow: 'މިހާރު ރިޔާސަތުގައި',
      actingBadge: 'ރިޔާސަތުގައި',
      noneActing: 'ހުރިހާ ފަރާތެއް ޗުއްޓީގައި — ރިޔާސަތު ބަލަހައްޓާނެ ފަރާތެއް ނެތް',
      onLeave: 'ޗުއްޓީގައި',
      moveUp: 'މައްޗަށް',
      moveDown: 'ތިރިއަށް',
    },
  },
  meetings: {
    title: 'ބައްދަލުވުންތައް', create: 'އައު ބައްދަލުވުމެއް', number: 'ބައްދަލުވުމުގެ ނަންބަރު',
    meetingTitle: 'ބައްދަލުވުމުގެ ނަން', date: 'ތާރީޚު', time: 'ގަޑި',
    dateTime: 'ތާރީޚާއި ގަޑި', location: 'ބައްދަލުވުން އޮންނަ ތަން',
    type: 'ބައްދަލުވުމުގެ ބާވަތް',
    typeLabel: { GENERAL: 'ޢާއްމު', EMERGENCY: 'ކުއްލި' } as Record<string, string>,
    recipients: 'އެޖެންޑާ ފޮނުވާ ފަރާތްތައް',
    recipientsHint: 'އެޖެންޑާ ފާސްވުމުން އީމެއިލް ފޮނުވޭނީ ހޮވާފައިވާ ފަރާތްތަކަށް އެކަނި',
    recipientsRequired: 'މަދުވެގެން އެއް ފަރާތް ހޮއްވަވާ',
    recipientsDefault: 'ވަކި ފަރާތެއް ހޮވިފައިނުވޭ — ބައްދަލުވުމުގެ ހުރިހާ މެންބަރުންނަށް ފޮނުވޭނެ',
    // Read-only "send details" receipt shown after the agenda passes (sent).
    sentDetailsTitle: 'އެޖެންޑާ ފޮނުވި ގޮތުގެ ތަފްސީލް',
    sentDateTime: 'ފޮނުވި ތާރީޚާއި ވަގުތު',
    sentMethod: 'ފޮނުވި ގޮތް',
    sentMethodEmail: 'އީމެއިލް',
    verifiedVia: 'ޔަގީންކުރި ގޮތް',
    verifiedAuditLog: 'ސިސްޓަމް އޮޑިޓް ލޮގް',
    sentRecipients: 'ފޮނުވި ފަރާތްތައް',
    sendErrorTitle: 'އެޖެންޑާ ފޮނުވުމުގައި މައްސަލައެއް ދިމާވެއްޖެ',
    sentPillOk: 'ފޮނުވިފައި',
    sentPillFailed: 'ނާކާމިޔާބު',
    // Document numbers panel (agenda / yaumiyya / ninmun) — manual override.
    numbers: 'ނަންބަރުތައް',
    numbersAgenda: 'އެޖެންޑާ',
    numbersYaumiyya: 'ޔައުމިއްޔާ',
    numbersNinmun: 'ނިންމުން',
    numbersHint: 'ބަދަލުކުރެވޭނީ ނަންބަރު އެކަނި. ފޯމެޓް ބަދަލުކުރައްވާނީ ސެޓިންގްސްއިން.',
    numbersNoFormat: 'ފޯމެޓެއް ކަނޑައަޅާފައި ނެތް',
    numbersLocked: 'މި ލިޔުން ސޮއިކުރުމަށް ފޮނުވިފައިވާތީ ނަންބަރު ބަދަލެއް ނުކުރެވޭނެ',
    numbersLockedShort: 'ބަންދުކުރެވިފައި',
    numbersTaken: 'މި ނަންބަރު މިހާރުވެސް ބޭނުންކޮށްފައި — އެހެން ނަންބަރެއް ޚިޔާރުކުރައްވާ',
    upcoming: 'ކުރިއަށް ހުރި', past: 'ނިމިފައި',
    search: 'ބައްދަލުވުމެއް ހޯދާ…',
    searchEmpty: 'ހޯއްދެވި އެއްޗެއް ނުފެނުނު',
    cancelMeeting: 'ބައްދަލުވުން ކެންސަލްކުރޭ',
    cancelConfirm: 'މި ބައްދަލުވުން ކެންސަލްކުރަންވީތަ؟',
    deleteMeeting: 'ބައްދަލުވުން ޑިލީޓްކުރޭ',
    deleteConfirm: 'މި ބައްދަލުވުން އެއްކޮށް ޑިލީޓްކުރަންވީތަ؟ މިއީ އަނބުރާ ނުގެނެވޭނެ ޢަމަލެކެވެ.',
    editMeeting: 'ބައްދަލުވުން އެޑިޓްކުރޭ',
    editYearError: 'އެހެން އަހަރަކަށް ބަދަލެއް ނުކުރެވޭނެ — ބައްދަލުވުމުގެ ނަންބަރު ގުޅިފައިވަނީ މި އަހަރާ. ބަދަލުކުރަން ބޭނުންނަމަ މި ބައްދަލުވުން ކެންސަލްކޮށް އައު ބައްދަލުވުމެއް ހައްދަވާ.',
    editLockedError: 'މި ބައްދަލުވުން މިހާރު އެޑިޓެއް ނުކުރެވޭނެ.',
    // Single overall meeting status (haalathu) — derived from meeting + agenda +
    // yaumiyya state. See lib/meetingStatus.ts.
    status: {
      SCHEDULED: 'ތާވަލުކުރެވިފައި',
      AGENDA_FINALIZED: 'އެޖެންޑާ ފާސްކުރެވިފައި',
      AGENDA_SENT: 'އެޖެންޑާ ފޮނުވިފައި',
      YAUMIYYA_PROGRESS: 'ޔައުމިއްޔާ ކުރަނީ',
      YAUMIYYA_DONE: 'ޔައުމިއްޔާ ފާސްވެފައި',
      COMPLETED: 'ފުރިހަމަ ކުރެވިފައި',
      CANCELLED: 'ކެންސަލްކޮށްފައި',
    } as Record<string, string>,
    empty: 'އަދި ބައްދަލުވުމެއް ނެތް', itemCount: 'އެޖެންޑާ އައިޓަމް',
    allTerms: 'ހުރިހާ ދައުރެއް', term: 'ދައުރު',
    markCompleted: 'ފުރިހަމަ ކުރެވިއްޖެކަމަށް ފާހަގަކުރައްވާ',
    markCompletedConfirm: 'މި ބައްދަލުވުން ފުރިހަމަ ކުރެވިއްޖެކަމަށް ފާހަގަކުރައްވަންތޯ؟ އޭގެ ފަހުން ބަދަލެއް ނުގެނެވޭނެ.',
    reopenCompleted: 'އަލުން ހުޅުވާ',
    reopenCompletedConfirm: 'ފުރިހަމަކޮށްފައިވާ މި ބައްދަލުވުން އަލުން ހުޅުވަންތޯ؟',
    completedNote: 'މި ބައްދަލުވުން ފުރިހަމަ ކުރެވިފައި',
    // Reschedule (post-finalize date/time or location change) — dialog + banner.
    reschedule: 'ފަސްކުރައްވާ',
    rescheduleTitle: 'ބައްދަލުވުން ފަސްކުރައްވާ',
    rescheduleWhen: 'އާ ތާރީޚާއި ގަޑި',
    rescheduleLocation: 'ތަން (އެދޭނަމަ)',
    rescheduleSubmit: 'ފަސްކުރައްވާ',
    rescheduleBanner: 'ފަސްކުރެވިފައި',
    rescheduleFromTo: '{from} ން {to} އަށް',
    rescheduleSendForSigning: 'ފަސްކުރެވި އެޖެންޑާ ސޮއިއަށް ފޮނުއްވާ',
    rescheduleYearError: 'އެހެން އަހަރަކަށް ފަސްނުކުރެވޭނެ — ބައްދަލުވުމުގެ ނަންބަރު ގުޅިފައިވަނީ މި އަހަރާ.',
    rescheduleNotAllowedError: 'މި ބައްދަލުވުން މިހާރު ފަސްނުކުރެވޭނެ.',
  },
  stats: {
    title: 'ތަފާސްހިސާބު',
    meetingsHeading: 'ބައްދަލުވުންތަކުގެ ޚުލާޞާ',
    submissionsHeading: 'އެޖެންޑާ ހުށަހެޅުންތައް',
    // Meetings table headers
    meeting: 'ބައްދަލުވުން',
    date: 'ބައްދަލުވުމުގެ ތާރީޚު',
    agendaSent: 'އެޖެންޑާ ފޮނުވި ތާރީޚު',
    agenda: 'އެޖެންޑާ',
    yaumiyya: 'ޔައުމިއްޔާ',
    ninmun: 'ނިންމުން',
    haaziree: 'ހާޒިރީ',
    // Submissions table headers
    submitter: 'ހުށަހެޅުއްވި ފަރާތް',
    total: 'ޖުމްލަ',
    approved: 'ފާސްކޮށްފައި',
    rejected: 'ބަލައިނުގަތް',
    pending: 'ނިންމަން ހުރި',
    totalSubmissions: 'ހުށަހެޅި ޖުމްލަ',
    submissionsTab: 'އެޖެންޑާ ހުށަހެޅުންތައް',
    summaryTab: 'ބައްދަލުވުމުގެ ހުލާސާ',
    attendanceTab: 'ހާޒިރީ',
    // Attendance (haaziree) tab
    attendance: {
      heading: 'މެންބަރުންގެ ހާޒިރީ',
      term: 'ދައުރު',
      allTerms: 'ހުރިހާ ދައުރެއް',
      member: 'މެންބަރު',
      attended: 'ހާޒިރުވި',
      absent: 'ހާޒިރުނުވި',
      meetings: 'ބައްދަލުވުން',
      rate: 'އިންސައްތަ',
      // "{count} ބައްދަލުވުން" — approved meetings counted line
      meetingsCounted: (count: number) => `${count} ބައްދަލުވުން`,
      noData: 'ފާސްކުރެވިފައިވާ ޔައުމިއްޔާއެއް އަދި ނެތް',
    },
    kpiMeetings: 'ޖުމްލަ ބައްދަލުވުން',
    kpiYaumiyya: 'ޔައުމިއްޔާ ފާސްކުރި',
    kpiNinmun: 'ނިންމުން ސޮއިކުރި',
    noData: 'މި މުއްދަތުގައި ހުށަހެޅުމެއް ނެތް',
    // Download final copies from the summary table
    downloads: 'ފައިނަލް ކޮޕީ',
    downloadAgenda: 'އެޖެންޑާ ޑައުންލޯޑްކުރޭ',
    downloadYaumiyya: 'ޔައުމިއްޔާ ޑައުންލޯޑްކުރޭ',
    downloadNinmun: 'ނިންމުން ޑައުންލޯޑްކުރޭ',
    downloadHaaziree: 'ހާޒިރީ ޑައުންލޯޑްކުރޭ',
    // Ninmun (council decision) status pill labels
    ninmunStatus: {
      SIGNED: 'ސޮއިކޮށްފައި',
      SIGNING: 'ސޮއިކުރަނީ',
      GENERATED: 'ތައްޔާރުކޮށްފައި',
      NONE: 'ނެތް',
    } as Record<string, string>,
    // Period selector
    period: {
      m3: '3 މަސް',
      m6: '6 މަސް',
      y1: '1 އަހަރު',
      custom: 'އިޚްތިޔާރީ',
      from: 'ފެށޭ',
      to: 'ނިމޭ',
    },
    complianceTab: 'މިންވަރު',
    compliance: {
      heading: 'ބައްދަލުވުމުގެ މިންވަރު',
      cadenceLabel: { WEEKLY: 'ކޮންމެ ހަފްތާއަކު', MONTHLY: 'ކޮންމެ މަހަކު' } as Record<string, string>,
      // "{held} ފަހަރުން {required} ފުރިހަމަ" — held-of-required summary line.
      heldOfRequired: (held: number, required: number) => `${required} ބައްދަލުވުމުން ${held} ފުރިހަމަ`,
      year: 'އަހަރު',
      required: 'ޖެހޭ',
      held: 'ފުރިހަމަ',
      missedKpi: 'ނުބޭއްވި',
      heatmapHeading: 'މިންވަރުތައް',
      currentPeriod: 'ހިނގަމުންދާ',
      missedHeading: 'ނުބޭއްވިހުރި ބައްދަލުވުންތައް',
      allMet: 'ހުރިހާ މިންވަރެއް ފުރިހަމަ',
      notConfigured: 'ބައްދަލުވުން ބޭއްވުމުގެ މިންވަރު އަދި ކަނޑައަޅާފައި ނެތެވެ.',
      notConfiguredHelp: 'ކައުންސިލުން ކޮންމެ ހަފްތާއަކު ނުވަތަ ކޮންމެ މަހަކު ބައްދަލުވުން ބާއްވަންޖެހޭ މިންވަރު ސެޓިންގްސްއިން ކަނޑައަޅުއްވާ.',
      configureLink: 'ސެޓިންގްސްއަށް ދޭ',
      // "{from} – {to}" period range
      rangeSep: '–',
    },
  },
  thanfeezu: {
    title: 'ތަންފީޒު',
    subtitle: 'ކައުންސިލްގެ ނިންމުންތައް ތަންފީޒުކުރުމުގެ ހާލަތު',
    status: {
      NOT_STARTED: 'ނުފެށޭ',
      ONGOING: 'ކުރިއަށްދަނީ',
      ON_HOLD: 'މަޑުޖައްސާފައި',
      IMPLEMENTED: 'ތަންފީޒުކޮށްފި',
    },
    all: 'ހުރިހާ',
    total: 'ޖުމްލަ ނިންމުން',
    pctImplemented: 'ތަންފީޒުކުރެވުނު',
    avgDays: 'ތަންފީޒުކުރަން ނެގި މެދުމިން',
    days: 'ދުވަސް',
    overdue: 'މުއްދަތު ފަހަނައަޅައިފައި',
    ninmunNumber: 'ނިންމުން ނަންބަރު',
    masala: 'މައްސަލަ',
    hushahelhun: 'ހުށަހެޅުން',
    decided: 'ނިންމި ގޮތް',
    note: 'ތަފްސީލް',
    targetDate: 'ކަނޑައެޅުނު ތާރީޚު',
    completedDate: 'ތަންފީޒުކުރި ތާރީޚު',
    save: 'ރައްކާކުރައްވާ',
    saved: 'ރައްކާކުރެވިއްޖެ',
    empty: 'ތަންފީޒުކުރަން ޖެހޭ ނިންމުމެއް އަދި ނެތް',
    emptyFilter: 'މި ހާލަތުގައި ނިންމުމެއް ނެތް',
    register: 'ތަންފީޒީ ރަޖިސްޓްރީ',
    decisions: 'ނިންމުންތައް',
    statusLabel: 'ހާލަތު',
    decidedDate: 'ނިންމި ތާރީޚު',
    rate: 'ތަންފީޒީ ނިސްބަތް',
    search: 'ނިންމުމެއް ހޯދާ…',
  },
  agenda: {
    title: 'އެޖެންޑާ', submitItem: 'އެޖެންޑާ އައިޓަމެއް ހުށަހަޅާ',
    category: 'ހުށަހަޅާ ބައި',
    categories: {
      GOVT_OFFICES: 'ސަރުކާރުގެ އޮފީސްތަކުން ހުށަހަޅާ ކަންކަން',
      COUNCIL_MEMBERS: 'ކައުންސިލު މެންބަރުން ހުށަހަޅާ ކަންކަން',
      COUNCIL_ADMIN: 'ކައުންސިލު އިދާރާއިން ހުށަހަޅާ ކަންކަން',
      OTHER: 'އެހެނިހެން ކަންކަން',
    } as Record<string, string>,
    // WDC overrides: «committee» wording instead of «council» (mirrors the
    // backend SECTION_HEADINGS_BY_BODY for WDC meetings).
    categoriesWdc: {
      GOVT_OFFICES: 'ސަރުކާރުގެ އޮފީސްތަކުން ހުށަހަޅާ ކަންކަން',
      COUNCIL_MEMBERS: 'ކޮމިޓީ މެންބަރުން ހުށަހަޅާ ކަންކަން',
      COUNCIL_ADMIN: 'އިދާރީ ގޮތުން ހުށަހަޅާ ކަންކަން',
      OTHER: 'އެހެނިހެން ކަންކަން',
    } as Record<string, string>,
    itemTitle: 'ސުރުޚީ', description: 'ތަފްސީލު', attachments: 'އެޓޭޗްމަންޓްތައް',
    addFiles: 'ފައިލް އެޓޭޗްކުރޭ',
    onBehalfOf: 'ހުށަހަޅުއްވާ ފަރާތް', onBehalfSelf: 'އަމިއްލައަށް',
    onBehalfBy: 'ސިސްޓަމަށް އެންޓަރ ކުރީ',
    edit: 'އެޑިޓްކުރޭ', remove: 'ނަގާ',
    removeConfirm: 'މި އައިޓަމް ނަގަންވީތަ؟',
    saveItem: 'ބަދަލު ސޭވްކުރޭ',
    resubmitHint: 'މި މައްސަލަ ފާސްކޮށްފައިވެއެވެ. އެޑިޓްކުރައްވައިފިނަމަ އަލުން ފާސްކުރުމަށް ރައީސަށް ފޮނުވޭނެއެވެ.',
    existingAttachments: 'މިހާރުގެ އެޓޭޗްމަންޓްތައް',
    addMoreFiles: 'އިތުރު ފައިލް އެޓޭޗްކުރޭ',
    approve: 'ފާސްކުރޭ', reject: 'ބަލައިނުގަނޭ',
    rejectReason: 'ބަލައިނުގަތް ސަބަބު', rejectReasonRequired: 'ސަބަބު ލިޔުއްވާ',
    status: {
      PENDING: 'ހުށަހެޅިފައި', APPROVED: 'ފާސްކޮށްފައި', REJECTED: 'ބަލައިނުގަތް',
    } as Record<string, string>,
    finalize: 'އެޖެންޑާ ފައިނަލްކުރޭ',
    finalizeConfirm: 'އެޖެންޑާ ފައިނަލްކުރުމުން އިތުރު އައިޓަމެއް ނުހުށަހެޅޭނެ. ކުރިއަށް ދާންވީތަ؟',
    reopen: 'އެޖެންޑާ އަލުން ހުޅުވާ',
    reopenConfirm: 'އެޖެންޑާ އަލުން ހުޅުވުމުން ބަދަލު ގެނެވޭނެ. ކުރިއަށް ދާންވީތަ؟',
    reopenSignedConfirm: 'އެޖެންޑާ އަލުން ހުޅުވުމުން އަލުން ސޮއިކުރަންޖެހޭނެ. ކުރިއަށްދާންވީތަ؟',
    signed: 'ސޮއިކޮށްފައި',
    documents: 'އެޖެންޑާ ޑޮކިއުމަންޓް', documentsSection: 'ލިޔެކިޔުންތައް', version: 'ވާޝަން', finalVersion: 'ފައިނަލް',
    regenerate: 'އަލުން އުފައްދާ',
    regenerating: 'ޑޮކިއުމަންޓް ތައްޔާރުކުރަނީ…',
    pdfNotReady: 'އެޖެންޑާ ޑޮކިއުމަންޓް ތައްޔާރުވަނީ. މަޑުކޮށްލައްވާ',
    submittedBy: 'ހުށަހެޅުއްވީ', empty: 'އަދި އައިޓަމެއް ނެތް',
    moveUp: 'މައްޗަށް', moveDown: 'ތިރިއަށް',
    pendingSection: 'ފާސްކުރަން ހުރި', approvedSection: 'ފާސްކޮށްފައިވާ', rejectedSection: 'ބަލައިނުގަތް',
    // Transfer (defer) approved agenda items to another scheduled meeting.
    transfer: {
      button: 'އެޖެންޑާ އައިޓަމްތައް އެހެން ބައްދަލުވުމަކަށް ފޮނުވާ',
      panelTitle: 'އެހެން ބައްދަލުވުމަކަށް ބަދަލުކުރުން',
      target: 'ބަދަލުކުރާ ބައްދަލުވުން',
      selectItems: 'ބަދަލުކުރާ އައިޓަމްތައް',
      confirmButton: 'ބަދަލުކުރޭ',
      confirm: (targetTitle: string) => `${targetTitle} އަށް މި އައިޓަމްތައް ބަދަލުކުރަންވީތަ؟`,
      moved: (n: number) => `${n} އައިޓަމް ބަދަލުކޮށްފި`,
      noTargets: 'ބަދަލުކުރެވޭނެ ތާވަލުކުރެވިފައިވާ ބައްދަލުވުމެއް ނެތް',
      // Note shown on the SOURCE meeting after its items were transferred away.
      noteHeading: 'ފޮނުވި އެޖެންޑާ އައިޓަމް',
      note: (count: number, target: string) => `${count} އެޖެންޑާ އައިޓަމް «${target}» އަށް ފޮނުވިފައި`,
      noteDate: 'ފޮނުވި ތާރީޚު',
    },
    // "What to do next" strip — short prompts describing the current state.
    nextAction: 'ދެން ކުރަންވީ',
    awaitingItems: 'އެޖެންޑާ އައިޓަމް ހުށަހެޅުމަށް ހުޅުވިފައި',
    awaitingFinalize: 'އެޖެންޑާ ފައިނަލްކުރުމަށް ތައްޔާރު',
    awaitingSigning: 'ރައީސްގެ ސޮއި ބޭނުންވޭ',
    finalizedDone: 'އެޖެންޑާ ފައިނަލްކޮށްފައި',
    sectionAgenda: 'އެޖެންޑާ',
    sectionStatus: 'ހާލަތު',
    sectionDetails: 'ބައްދަލުވުމުގެ ތަފްސީލު',
    // WapSign signing flow (president signs the agenda to pass it).
    sendForSigning: 'ސޮއިކުރުމަށް ފޮނުވާ',
    signingInProgress: 'ސޮއިކުރުމަށް ފޮނުވާފައި',
    openInWapsign: 'ވެޕްސައިން ގައި ހުޅުވާ',
    agendaPassed: 'އެޖެންޑާ ފާސްވެއްޖެ',
    wapsignNoAccount: 'ވެޕްސައިން އެކައުންޓެއް ނެތް',
  },
  talkingPoints: {
    title: 'ވާހަކަ ދައްކާ ނުކުތާތައް',
    add: 'އިތުރުކުރޭ',
    placeholder: 'ނުކުތާ ލިޔުއްވާ...',
    empty: 'އަދި ނުކުތާއެއް އިތުރުކޮށްފައެއް ނެތް',
    edit: 'އެޑިޓްކުރޭ',
    save: 'ރައްކާކުރޭ',
    cancel: 'ކެންސަލް',
    delete: 'ފޮހެލާ',
    deleteConfirm: 'މި ނުކުތާ ފޮހެލަންތޯ؟',
    saving: 'ރައްކާކުރަނީ…',
    saved: 'ރައްކާކޮށްފި',
    done: 'ނިމުނީ',
    addPrompt: 'ނުކުތާ އިތުރުކުރައްވާ',
  },
  notes: {
    title: 'މީޓިން ނޯޓްސް',
    entry: 'މީޓިން ނޯޓްސް',
    placeholder: 'ނުކުތާ ލިޔުއްވާ...',
    privateHint: 'މި ނުކުތާތައް ފެންނާނީ ހަމައެކަނި ތިޔަ ބޭފުޅާއަށެވެ',
    // The meeting-wide pad, as opposed to the per-agenda-item pages. Composed
    // from this app's own shipped words: «ޢާއްމު» exactly as in meetings
    // typeLabel.GENERAL, and «ނޯޓް» as in notes.title. CONFIRM WITH THE USER.
    generalPage: 'ޢާއްމު ނޯޓް',
    // Marks a page whose agenda item has been withdrawn or sent back for
    // re-approval. The page and its text are kept — only the author may remove
    // their own writing. CONFIRM WITH THE USER.
    offAgenda: 'އެޖެންޑާގައި ނެތް',
    regenerate: 'އުފައްދާ',
    regenerateConfirm: 'ލިޔެފައިވާ ނުކުތާތައް ބަދަލުވާނެ. ކުރިއަށް ދާންވީތަ؟',
    // Full-screen read-only lectern view; value copied verbatim from WapDocs.
    present: 'ޕްރިވިއު',
    // Editor toolbar — copied verbatim from WapDocs' shipped Dhivehi copy
    // (same TipTap toolbar); `italic` follows its transliteration pattern.
    bold: 'ބޯލްޑް',
    italic: 'އިޓަލިކް',
    underline: 'އަންޑަރލައިން',
    heading2: 'ސުރުޚީ 2',
    heading3: 'ސުރުޚީ 3',
    bulletList: 'ބުލެޓް ލިސްޓް',
    orderedList: 'ނަންބަރު ލިސްޓް',
    alignRight: 'ކަނާތްފަރާތަށް',
    alignCenter: 'މެދަށް',
    alignJustify: 'ދެފަރާތަށް ހަމަކުރޭ',
    // Table controls. «އިތުރުކުރޭ» and «ނަގާ» are this app's shipped words for
    // add/remove (yaumiyya.addRow / removeRow), and «ތާވަލު» is the root of the
    // shipped «ތާވަލުކުރެވިފައި». «ސަފު» (row) and «ކޮލަމް» (column) are the two
    // genuinely new words here. CONFIRM WITH THE USER.
    table: 'ތާވަލު',
    tableAddRow: 'ސަފު އިތުރުކުރޭ',
    tableAddColumn: 'ކޮލަމް އިތުރުކުރޭ',
    tableDeleteRow: 'ސަފު ނަގާ',
    tableDeleteColumn: 'ކޮލަމް ނަގާ',
    tableDelete: 'ތާވަލު ނަގާ',
  },
  yaumiyya: {
    title: 'ޔައުމިއްޔާ',
    write: 'ޔައުމިއްޔާ ލިޔޭ', edit: 'ޔައުމިއްޔާ އެޑިޓްކުރޭ',
    saving: 'ސޭވްކުރަނީ…', saved: 'އޮޓޮމެޓިކުން ސޭވްކޮށްފި',
    arrivalTime: 'ހާޟިރުވި ގަޑި',
    attendanceMode: 'ހާޟިރުވި ގޮތް',
    modePhysical: 'ފިޒިކަލްކޮށް',
    modeOnline: 'އޮންލައިންކޮށް',
    attendance: 'ހާޒިރުވި މެންބަރުން',
    notePlaceholder: 'މި އައިޓަމާ ގުޅޭ ޔައުމިއްޔާ ނޯޓް…',
    submit: 'ފާސްކުރުމަށް ހުށަހަޅާ',
    submitConfirm: 'ޔައުމިއްޔާ ފާސްކުރުމަށް ހުށަހަޅަންވީތަ؟',
    withdraw: 'އަނބުރާ ގެނޭ',
    reopen: 'ޔައުމިއްޔާ އަލުން ހުޅުވާ',
    reopenConfirm: 'ޔައުމިއްޔާ އަލުން ހުޅުވުމުން އަލުން ސޮއިކުރަންޖެހޭނެ. ކުރިއަށްދާންވީތަ؟',
    signed: 'ސޮއިކޮށްފައި',
    approve: 'ފާސްކުރޭ',
    approveConfirm: 'މި ޔައުމިއްޔާ ފާސްކުރަންވީތަ؟',
    approved: 'ފާސްކޮށްފައި',
    approvalProgress: 'ފާސްކުރި މެންބަރުން',
    status: { DRAFT: 'ޑްރާފްޓް', PENDING_APPROVAL: 'ފާސްކުރުމަށް ހުށަހެޅިފައި', APPROVED: 'ފާސްކޮށްފައި' } as Record<string, string>,
    notYet: 'ޔައުމިއްޔާ އަދި ނުލިޔޭ',
    document: 'ޔައުމިއްޔާ ޑޮކިއުމަންޓް',
    preview: 'ޕްރިވިއު',
    youApproved: 'ތިޔަ ފާސްކުރައްވައިފި',
    chair: 'ރިޔާސަތު ބެލެހެއްޓެވީ',
    startedTime: 'ފެށުނު ގަޑި',
    interruptedTime: 'މެދުކަނޑާލި ގަޑި',
    resumedTime: 'މެދުކަނޑާލުމަށްފަހު ފެށި ގަޑި',
    endedTime: 'ނިމުނު ގަޑި',
    openingText: 'ރިޔާސަތުން ބައްދަލުވުން ފެށުން',
    closingText: 'ބައްދަލުވުން ނިންމުން',
    meta: 'ބައްދަލުވުމުގެ މަޢުލޫމާތު',
    attended: 'ހާޟިރުވި ފަރާތްތައް',
    absent: 'ހާޟިރުނުވި ފަރާތްތައް',
    absentReason: 'ސަބަބު',
    secretariat: 'ސެކްރެޓޭރިއެޓް',
    observers: 'އަޑުއެހުމަށް ހާޟިރުވި ފަރާތްތައް',
    observerAddress: 'އެޑްރެސް',
    observerRole: 'މަޤާމު',
    name: 'ނަން',
    role: 'މަޤާމު',
    addRow: 'އިތުރުކުރޭ',
    removeRow: 'ނަގާ',
    discussion: 'މަޝްވަރާގެ ތަފްސީލު',
    decision: 'ނިންމިގޮތް',
    proposedBy: 'ހުށަހެޅި ފަރާތް',
    secondedBy: 'ތާއީދު ކުރެއްވި',
    proposal: 'ހުށަހެޅުން',
    proposalText: 'ހުށަހެޅުން',
    addProposal: 'ހުށަހެޅުމެއް އިތުރުކުރައްވާ',
    removeProposal: 'ހުށަހެޅުން ނަންގަވާ',
    votesFor: 'ފެންނަކަމަށް ވޯޓު ދެއްވި',
    votesAgainst: 'ނުފެންނަކަމަށް ވޯޓު ދެއްވި',
    voteDetail: 'ވޯޓު ދިނުމުގެ ތަފްސީލު',
    voteTableName: 'ނަން',
    fenna: 'ފެންނަ',
    nufenna: 'ނުފެންނަ',
    // No-quorum: the meeting wasn't validly held, so discussion/voting is hidden.
    quorumNotMet: 'ކޯރަމް ހަމަނުވޭ — ބައްދަލުވުން ކުރިއަކަށް ނުގެންދެވުނު',
    // "ބޭނުންވަނީ X · ހާޟިރުވީ Y" — required vs present counts.
    quorumCounts: (required: number, present: number) => `ބޭނުންވަނީ ${required} · ހާޟިރުވީ ${present}`,
    // WapSign signing flow.
    sendForSigning: 'ސޮއިކުރުމަށް ފޮނުވާ',
    signingInProgress: 'ސޮއިކުރުމަށް ފޮނުވާފައި',
    openInWapsign: 'ވެޕްސައިން ގައި ހުޅުވާ',
    preparingSigning: 'ސޮއިކުރުމަށް ތައްޔާރުކުރަނީ…',
    wapsignNoAccount: 'ވެޕްސައިން އެކައުންޓެއް ނެތް',
    generateDiscussion: 'ތަފްސީލް އުފައްދާ',
    regenerate: 'އަލުން އުފައްދާ',
    useDraft: 'ބޭނުންކުރޭ',
    generating: 'އުފައްދަނީ…',
    generateError: 'ތަފްސީލް އުފެއްދުމުގައި މައްސަލައެއް ދިމާވެއްޖެ',
    noTalkingPoints: 'ވާހަކަ ދައްކާ ނުކުތާއެއް އިތުރުކޮށްފައި ނެތުމުން އުފެއްދޭކަށް ނެތް',
    membersSpoke: 'ވާހަކަދެއްކި ނުކުތާތައް',
    addSpeaker: 'ވާހަކަދެއްކި ނުކުތާ އިތުރުކުރައްވާ',
    pickCouncilor: 'މެންބަރު ނަންގަވާ',
    speakerPoint: 'ފާހަގަކުރެއްވި ނުކުތާ',
  },
  ninmun: {
    title: 'ކައުންސިލްގެ ނިންމުން',
    download: 'ނިންމުން ޑައުންލޯޑް',
    number: 'ނިންމުން ނަންބަރު',
    // WapSign signing flow (acting president signs the ninmun).
    sendForSigning: 'ނިންމުން ސޮއިކުރުމަށް ފޮނުވާ',
    signingInProgress: 'ސޮއިކުރުމަށް ފޮނުވާފައި',
    openInWapsign: 'ވެޕްސައިން ގައި ހުޅުވާ',
    signed: 'ސޮއިކޮށްފައި',
  },
  haaziree: {
    title: 'ބައްދަލުވުމުގެ ހާޟިރީ',
    download: 'ހާޟިރީ ޑައުންލޯޑް',
    // WapSign signing flow (acting president signs the haaziree).
    sendForSigning: 'ހާޟިރީ ސޮއިކުރުމަށް ފޮނުވާ',
    signingInProgress: 'ސޮއިކުރުމަށް ފޮނުވާފައި',
    openInWapsign: 'ވެޕްސައިން ގައި ހުޅުވާ',
    signed: 'ސޮއިކޮށްފައި',
  },
  notifications: {
    title: 'ނޮޓިފިކޭޝަން', empty: 'ނޮޓިފިކޭޝަނެއް ނެތް', markAllRead: 'ހުރިހާ އެއްޗެއް ކިޔިއްޖެ',
  },
  dashboard: {
    welcome: 'މަރުޙަބާ', upcomingMeetings: 'ކުރިއަށް ހުރި ބައްދަލުވުންތައް',
    viewAll: 'ހުރިހާ ބައްދަލުވުންތައް',
    nextMeeting: 'އެންމެ އަވަހަށް އޮތް ބައްދަލުވުން',
    startsIn: 'ފެށެން ބާކީ',
    startedNow: 'ބައްދަލުވުމުގެ ވަގުތު ޖެހިއްޖެ',
    submitItemCta: 'މައްސަލަ އެޖެންޑާ ކުރޭ',
    openMeeting: 'ބައްދަލުވުމަށް ދޭ',
    days: 'ދުވަސް', hours: 'ގަޑިއިރު', minutes: 'މިނިޓް', seconds: 'ސިކުންތު',
    noUpcoming: 'ކުރިއަށް ބައްދަލުވުމެއް ނެތް',
    pastMeetings: 'ފަހުގެ ބައްދަލުވުންތައް',
    leaderboard: {
      title: 'މައްސަލަ ހުށަހަޅާފައިވާ މިންވަރު',
      subtitle: 'ފާސްވި މައްސަލަ',
      masala: 'މައްސަލަ',
      ofProposed: 'ހުށަހެޅުއްވި',
      empty: 'މި އަހަރު އަދި ފާސްވި މައްސަލައެއް ނެތް',
    },
  },
  notFound: { title: 'ޞަފްޙާ ނުފެނުނު', home: 'ފުރަތަމަ ޞަފްޙާއަށް' },
} as const;
